
import React, { useRef, useState } from "react";
import Slider from "react-slick";

export default function HomeInspire() {
    const [isHovered, setIsHovered] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);
    const [isHovered3, setIsHovered3] = useState(false);
    const [isHovered4, setIsHovered4] = useState(false);

    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
        responsive: [
            {
                breakpoint: 767,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 599,
                settings: { slidesToShow: 1 },
            },
        ],
    };

    return (
        <>
            <div className="home-inspire">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="inspire-head">
                                <h1 className="heading">Experience Excellence at LPS</h1>
                                <p>At Lucknow Public School, excellence is a way of life. We provide a nurturing environment where discipline, quality education, and strong values inspire every learner to achieve their
                                    fullest potential. Guided by dedicated educators and enriched through academics, co-curricular activities, and leadership opportunities, our students develop confidence, integrity, and a lifelong commitment to learning, service, and responsible citizenship.</p>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-center">
                        <div className="col-lg-4 col-md-4 hidefor-slider">
                             
                            <div className="inspire-tagbox-2 right-tagbox wow animate__animated animate__slideInLeft" data-wow-delay="0.1s" data-wow-duration="1s">
                                <div className="instag-detail">
                                    <span>1988</span>
                                    <p>Established</p>
                                </div>
                                <img src="/image/inspire-tag-2.webp" className="img-responsive" alt="inspire" loading="lazy" />
                            </div>

                            <div className="inspire-tagbox-1 right-tagbox wow animate__animated animate__slideInLeft">
                                <div className={`instag-detail ${isHovered ? "show-before" : ""}`} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                                    <span>10</span>
                                    <p>Branches Across U.P</p>
                                </div>
                                <img src="/image/inspire-tag-1.webp" className="img-responsive child-img1" alt="inspire" loading="lazy" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} />

                                <div className={`instag-detail ${isHovered ? "" : "show-after"}`} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                                    <span>10</span>
                                    <p>Branches Across U.P</p>
                                </div>
                                <img src="/image/inspire-tag-1b.webp" className="img-responsive child-img2" alt="inspire" loading="lazy" />
                            </div>


                            <div className="inspire-tagbox-3 right-tagbox wow animate__animated animate__slideInLeft" data-wow-delay="0.1s" data-wow-duration="1s">
                                <div className={`instag-detail ${isHovered2 ? "show-before" : ""}`} onMouseEnter={() => setIsHovered2(true)} onMouseLeave={() => setIsHovered2(false)}>
                                    <span>CBSE</span>
                                    <p>Board Affiliation</p>
                                </div>
                                <img src="/image/inspire-tag-3.webp" className="img-responsive child-img1" alt="inspire" loading="lazy" onMouseEnter={() => setIsHovered2(true)} onMouseLeave={() => setIsHovered2(false)} />

                                <div className={`instag-detail ${isHovered2 ? "" : "show-after"}`} onMouseEnter={() => setIsHovered2(true)} onMouseLeave={() => setIsHovered2(false)}>
                                    <span>9</span>
                                    <p>CBSE Affiliated</p>
                                </div>
                                <img src="/image/inspire-tag-3b.webp" className="img-responsive child-img2" alt="inspire" loading="lazy" />
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-4">
                            <div className="inspire-bigimage">
                                <img src="/image/inspire-circle.webp" className="img-responsive" alt="inspire" loading="lazy" />
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-4 hidefor-slider">
                            <div className="inspire-tagbox-4 left-tagbox wow animate__animated animate__slideInRight">
                                <div className={`instag-detail ${isHovered3 ? "show-before" : ""}`} onMouseEnter={() => setIsHovered3(true)} onMouseLeave={() => setIsHovered3(false)}>
                                    <p>Total Students All branches</p>
                                    <span>17K+</span>
                                </div>
                                <img src="/image/inspire-tag-4.webp" className="img-responsive child-img1" alt="inspire" loading="lazy" />

                                <div className={`instag-detail ${isHovered3 ? "" : "show-after"}`} onMouseEnter={() => setIsHovered3(true)} onMouseLeave={() => setIsHovered3(false)}>
                                    <p>Total Students All branches</p>
                                    <span>17K+</span>
                                </div>
                                <img src="/image/inspire-tag-4b.webp" className="img-responsive child-img2" alt="inspire" loading="lazy" onMouseEnter={() => setIsHovered3(true)} onMouseLeave={() => setIsHovered3(false)} />
                            </div>

                            <div className="inspire-tagbox-5 left-tagbox wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="1s">
                                <div className={`instag-detail ${isHovered4 ? "show-before" : ""}`} onMouseEnter={() => setIsHovered4(true)} onMouseLeave={() => setIsHovered4(false)}>
                                    <p>Class X Top Score</p>
                                    <span>99.2%</span>
                                </div>
                                <img src="/image/inspire-tag-5.webp" className="img-responsive child-img1" alt="inspire" loading="lazy" />

                                <div className={`instag-detail ${isHovered4 ? "" : "show-after"}`} onMouseEnter={() => setIsHovered4(true)} onMouseLeave={() => setIsHovered4(false)}>
                                    <p>Class X Top Score</p>
                                    <span>99.2%</span>
                                </div>
                                <img src="/image/inspire-tag-5b.webp" className="img-responsive child-img2" alt="inspire" loading="lazy" onMouseEnter={() => setIsHovered4(true)} onMouseLeave={() => setIsHovered4(false)} />
                            </div>

                            <div className="inspire-tagbox-6 left-tagbox wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="1s">
                                <div className="instag-detail">
                                    <p>Class XII Top Score</p>
                                    <span>98.2%</span>
                                </div>
                                <img src="/image/inspire-tag-6.webp" className="img-responsive" alt="inspire" loading="lazy" />
                            </div>
                        </div>


                        <div className="col-lg-12 mobileview-slider inspire-mobile">
                            <Slider {...settings} ref={sliderRef}>
                                <div className="inspire-tagbox-1 left-tagbox wow animate__animated animate__slideInLeft">
                                    <div className={`instag-detail ${isHovered ? "show-before" : ""}`} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                                        <p>Branches Across U.P</p>
                                        <span>10</span>
                                    </div>
                                    <img src="/image/inspire-tag-1.webp" className="img-responsive child-img1" alt="inspire" loading="lazy" />

                                    <div className={`instag-detail ${isHovered ? "" : "show-after"}`} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                                        <p>Branches Across U.P</p>
                                        <span>10</span>
                                    </div>
                                    <img src="/image/inspire-tag-1b.webp" className="img-responsive child-img2" alt="inspire" loading="lazy" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} />
                                </div>

                                <div className="inspire-tagbox-2 left-tagbox wow animate__animated animate__slideInLeft" data-wow-delay="0.1s" data-wow-duration="1s">
                                    <div className="instag-detail">
                                        <p>Campus Area</p>
                                        <span>14 acres</span>
                                    </div>
                                    <img src="/image/inspire-tag-2.webp" className="img-responsive" alt="inspire" loading="lazy" />
                                </div>

                                <div className="inspire-tagbox-3 left-tagbox wow animate__animated animate__slideInLeft" data-wow-delay="0.1s" data-wow-duration="1s">
                                    <div className={`instag-detail ${isHovered2 ? "show-before" : ""}`} onMouseEnter={() => setIsHovered2(true)} onMouseLeave={() => setIsHovered2(false)}>
                                        <span>9</span>
                                        <p>CBSE Affiliated</p>
                                    </div>
                                    <img src="/image/inspire-tag-3.webp" className="img-responsive child-img1" alt="inspire" loading="lazy" />

                                    <div className={`instag-detail ${isHovered2 ? "" : "show-after"}`} onMouseEnter={() => setIsHovered2(true)} onMouseLeave={() => setIsHovered2(false)}>
                                        <span>9</span>
                                        <p>CBSE Affiliated</p>
                                    </div>
                                    <img src="/image/inspire-tag-3b.webp" className="img-responsive child-img2" alt="inspire" loading="lazy" onMouseEnter={() => setIsHovered2(true)} onMouseLeave={() => setIsHovered2(false)} />
                                </div>

                                <div className="inspire-tagbox-4 left-tagbox wow animate__animated animate__slideInRight">
                                    <div className={`instag-detail ${isHovered3 ? "show-before" : ""}`} onMouseEnter={() => setIsHovered3(true)} onMouseLeave={() => setIsHovered3(false)}>
                                        <p>Total Students All branches</p>
                                        <span>14K+</span>
                                    </div>
                                    <img src="/image/inspire-tag-4.webp" className="img-responsive child-img1" alt="inspire" loading="lazy" />

                                    <div className={`instag-detail ${isHovered3 ? "" : "show-after"}`} onMouseEnter={() => setIsHovered3(true)} onMouseLeave={() => setIsHovered3(false)}>
                                        <p>Total Students All branches</p>
                                        <span>14K+</span>
                                    </div>
                                    <img src="/image/inspire-tag-4b.webp" className="img-responsive child-img2" alt="inspire" loading="lazy" onMouseEnter={() => setIsHovered3(true)} onMouseLeave={() => setIsHovered3(false)} />
                                </div>

                                <div className="inspire-tagbox-5 left-tagbox wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="1s">
                                    <div className={`instag-detail ${isHovered4 ? "show-before" : ""}`} onMouseEnter={() => setIsHovered4(true)} onMouseLeave={() => setIsHovered4(false)}>
                                        <p>Class X Top Score</p>
                                        <span>98.8%</span>
                                    </div>
                                    <img src="/image/inspire-tag-5.webp" className="img-responsive child-img1" alt="inspire" loading="lazy" />

                                    <div className={`instag-detail ${isHovered4 ? "" : "show-after"}`} onMouseEnter={() => setIsHovered4(true)} onMouseLeave={() => setIsHovered4(false)}>
                                        <p>Class X Top Score</p>
                                        <span>98.8%</span>
                                    </div>
                                    <img src="/image/inspire-tag-5b.webp" className="img-responsive child-img2" alt="inspire" loading="lazy" onMouseEnter={() => setIsHovered4(true)} onMouseLeave={() => setIsHovered4(false)} />
                                </div>

                                <div className="inspire-tagbox-6 left-tagbox wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="1s">
                                    <div className="instag-detail">
                                        <p>Class XII Top Score</p>
                                        <span>98.8%</span>
                                    </div>
                                    <img src="/image/inspire-tag-6.webp" className="img-responsive" alt="inspire" loading="lazy" />
                                </div>
                            </Slider>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
